var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":"/Project/Create"}},[_c('button',{staticClass:"btn-solid my-2 flex items-center rounded border border-gray-500 text-sm text-gray-700 hover:bg-gray-100"},[_c('b-icon',{staticClass:"mr-1 w-5 text-gray-700",attrs:{"name":"plus"}}),_vm._v(" New project ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }